import React, {useReducer, useEffect, useContext, useRef } from "react";
import nivel3Context from "./nivel3Context";
import { getAllNivel3s, addNivel3, updateNivel3, deleteNivel3, updatePositioning, deleteNivel3AndChildren} from "../../api/nivel3";
import nivel3Reducer from "./nivel3Reducer";
import authContext from "../authentication/authContex";

//Types
import { 
    ACTUALIZAR_LIST_NIVEL3,
  } from "./nivel3Actions";
import { SocketContext } from "../socket/socket";
import Swal from "sweetalert2";


const Nivel3State = props =>{
     
    const initialState = {
        nivel3List: null
     };

    const [state, dispatch] = useReducer(nivel3Reducer, initialState);
    
    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;
    const server = useContext(SocketContext);
    const nivel3ListRef = useRef(state.nivel3List);

    const actualizarNivel3 = async () => {
        try{
            const resp = await getAllNivel3s();
            let nivel3 = resp.data.data;
            nivel3 = nivel3.map((lv3,i) => ({...lv3, position: lv3.position ?? i + 1})); 
            nivel3ListRef.current = nivel3;
            dispatch({
                type:  ACTUALIZAR_LIST_NIVEL3,
                payload: nivel3
            });
            
            return nivel3;
        }catch(err){
            console.log(err)
        }

    };
    
    const agregarNivel3 = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addNivel3
            const resp = await addNivel3(dato);
            const nivel3 = resp.data.data;
            return {saved:true, lv3Saved: nivel3};
        }catch(err){
            console.log(err);
            let msg = err.response?.data?.message ?? 'Error desconocido'
            let customMsg = msg.includes("duplicate key error") ? 'Código o Nombre se está repitiendo.' : msg;
            return {saved: false, msg: customMsg};
        }
    };

    const modificarNivel3 = async (dato) => {
        try{
            const resp = await updateNivel3(dato);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel3 = async (id) => {
        try{
            
            const resp = await deleteNivel3(id);
            const nivel3 = resp.data.data;
            return nivel3;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel3eHijos = async(id, deleteActivesToo = false, from = '') => {
        try {

            const resp = await deleteNivel3AndChildren(id, deleteActivesToo);
            const nivel3 = resp.data.data;
            const swalConfig = {title:'Eliminado!', html: nivel3, icon:'success'};
            if(from === 'TreeActivo') return swalConfig;
            Swal.fire(swalConfig);
            return nivel3;
        } catch (error) {
            console.log(error)
            const errorConfig = {title:'Ops!', text: error?.response?.data?.data ?? 'Error al eliminar', icon:'error'};
            if(from === 'TreeActivo') return errorConfig;
            if(error.response?.status == 401) Swal.fire(errorConfig);
        }
    }
    
    const updatePositionLv3 = async (updates) => {
        let lvs3Updated = nivel3ListRef.current ?? [];
        lvs3Updated = lvs3Updated.map(a => {
            let lvFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: lvFound ? lvFound.position : a.position
            }
        });
        nivel3ListRef.current = lvs3Updated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_NIVEL3,
            payload: lvs3Updated
        });
    }

    useEffect(() => {
      if(usuario != null) actualizarNivel3();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('nivel3sUpdated', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server nivel3sUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel3();
                }
            });

            server.on('nivel3Eliminated', ({tenantId}) => {
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel3();
                }
            })
            
            return () => {
                server.off('nivel3sUpdated');
                server.off('nivel3Eliminated');
            }
        }
    },[server])

    return(
        <nivel3Context.Provider
            value={{
                nivel3List: state.nivel3List,
                actualizarNivel3,
                agregarNivel3,
                modificarNivel3,
                eliminarNivel3,
                eliminarNivel3eHijos,
                updatePositionLv3,
            }}
        >
            {props.children}
        </nivel3Context.Provider>
    )

}

export default Nivel3State;